import * as faceapi from 'face-api.js';

const maxDescriptorDistance = 0.5;

export async function loadModels() {
  const MODEL_URL = process.env.PUBLIC_URL + '/models';
  await faceapi.loadTinyFaceDetectorModel(MODEL_URL);
  await faceapi.loadFaceLandmarkTinyModel(MODEL_URL);
  await faceapi.loadFaceRecognitionModel(MODEL_URL);
  await faceapi.loadFaceExpressionModel(MODEL_URL);
}

export async function getFullFaceDescription(blob, inputSize = 512) {
  // tiny_face_detector options
  let scoreThreshold = 0.5;
  const OPTION = new faceapi.TinyFaceDetectorOptions({
    inputSize,
    scoreThreshold
  });
  const useTinyModel = true;

  // fetch image to api
  let img;
  try {
    img = await faceapi.fetchImage(blob);
    //console.log(img);
  } catch (error) {
    console.log(error);
    return ;
  }

  // detect all faces and generate full description from image
  // including landmark and descriptor of each face
  // let fullDesc = await faceapi
  //   .detectAllFaces(img, OPTION)
  //   .withFaceLandmarks(useTinyModel)
  //   .withFaceDescriptors();

  const OPTION1 = new faceapi.TinyFaceDetectorOptions ({
    inputSize,
    scoreThreshold
  });
  // //await faceapi.loadFaceExpressionModel('/models');
  // let detectionWithExpressions = await faceapi.detectAllFaces(img, OPTION1)
  // .withFaceLandmarks(useTinyModel).withFaceExpressions().withFaceDescriptors();
  // console.log("===> Expression :  " + detectionWithExpressions);

  // let fullDesc = await faceapi
  //   .detectAllFaces(img, OPTION)
  //   .withFaceLandmarks(useTinyModel)
  //   .withFaceDescriptors();

  // let fullDesc = await faceapi
  //   .detectAllFaces(img, OPTION)
  //   .withFaceLandmarks(useTinyModel).withFaceDescriptors();
  let fullDesc = await faceapi
    .detectAllFaces(img, OPTION)
    .withFaceLandmarks(useTinyModel).withFaceExpressions().withFaceDescriptors();

  //let leftEye = fl.faceLandmarks.getLeftEye();
  //console.log("---->" + fullDesc);
  //let fullDesc = await facelandmarks.withFaceDescriptors();

  //console.log("Left Eye : " + leftEye); 
  
  // if (fullDesc.length > 0){
  //   //let le = fullDesc[0].landmarks.getLeftEye();

  //   let fex = fullDesc[0].expressions;
  //   //console.log("FEX:Ang(" + fex.angry.toFixed(2) + ");Disg(" + fex.disgusted.toFixed(2) + ");Fear("+ fex.fearful.toFixed(2) + ");Happy(" + fex.happy.toFixed(2) + ");Neu(" + fex.neutral.toFixed(2) +");Sad("+ fex.sad.toFixed(2) + ");Surp(" + fex.surprised.toFixed(2) +")"); 

  //   let fl = fullDesc[0].landmarks;
  //   //console.log("Jaw : " + JSON.stringify(fl.getJawOutline()));

  //   let le = fullDesc[0].landmarks.getLeftEye();
    
  //   console.log("Left Eye : " + JSON.stringify(le)); 

  // }

  return fullDesc;
}

export async function createMatcher(faceProfile) {
  // Create labeled descriptors of member from profile
  let members = Object.keys(faceProfile);
  let labeledDescriptors = members.map(
    member =>
      new faceapi.LabeledFaceDescriptors(
        faceProfile[member].name,
        faceProfile[member].descriptors.map(
          descriptor => new Float32Array(descriptor)
        )
      )
  );

  // Create face matcher (maximum descriptor distance is 0.5)
  let faceMatcher = new faceapi.FaceMatcher(
    labeledDescriptors,
    maxDescriptorDistance
  );
  return faceMatcher;
}

export function isFaceDetectionModelLoaded() {
  return !!faceapi.nets.tinyFaceDetector.params;
}
